import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-content neon" }
const _hoisted_2 = { class: "cards" }
const _hoisted_3 = {
  ref: "viewer",
  class: "cam-wrap"
}
const _hoisted_4 = {
  ref: "video",
  autoplay: "",
  playsinline: "",
  muted: ""
}
const _hoisted_5 = {
  ref: "overlay",
  class: "overlay"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_color_card = _resolveComponent("app-color-card")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_AppShutterButton = _resolveComponent("AppShutterButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.modalRef)
      ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
          key: 1,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
          width: _ctx.isMobile ? 300 : 550,
          target: _ctx.modalRef,
          position: {
        x: 'left',
        y: 'center',
      }
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
                return (_openBlock(), _createBlock(_component_app_color_card, {
                  key: card.id,
                  index: index,
                  card: card,
                  "is-selected": _ctx.selectedCard?.id === card?.id,
                  onSelected: _ctx.selected
                }, null, 8, ["index", "card", "is-selected", "onSelected"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible", "width", "target"]))
      : _createCommentVNode("", true),
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("video", _hoisted_4, null, 512),
      _createElementVNode("canvas", _hoisted_5, null, 512)
    ], 512),
    (!_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
          _createElementVNode("div", {
            class: "image",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBackWithResult && _ctx.goBackWithResult(...args)))
          }, [
            (_ctx.photo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.photo,
                  alt: "photo"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AppShutterButton, { onCapture: _ctx.takePhotoWithFrameMasked }, null, 8, ["onCapture"])
          ]),
          _createElementVNode("div", {
            ref: "modalRef",
            class: "settings",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openOverlayPanel && _ctx.openOverlayPanel(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              size: "xl",
              icon: ['fas', 'sliders']
            })
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}